import SelectColumnCell from './SelectColumnCell';
import SelectColumnHeader from './SelectColumnHeader';

export const filterTooltipText = 'Filter the table';
export const resetFilterTooltipText = 'Reset all filters';
export const verifyCoordinatesSelectedTooltipText = 'Verify Sites coordinates';
export const deleteSelectedTooltipText = 'Delete selected entries';
export const unlinkSelectedTooltipText = 'Unlink selected entries';
export const exportTooltipDefaultText = 'Export';
export const setExportRulesTooltipText = 'Set export rules';
export const defaultSearchTooltipText = 'Search';
export const pinColumns = 'Pin columns';
export const unpinColumns = 'Unpin columns';
export const refreshAction = 'Refresh';
export const assetVisibilityTooltipText = 'Show/Hide on the map';
export const setCommonValuesTooltipText = 'Set common values';

export const statusOptions = [
	{
		label: 'Active',
		value: true,
	},
	{
		label: 'Blocked',
		value: false,
	},
];

export const selectColumn = ([
	{
		id: 'select-col',
		header: SelectColumnHeader,
		cell: SelectColumnCell,
	},
]);

export const DRAG_ACTIVATION_DISTANCE = 5;
export const DEFAULT_DRAG_HANDLE_SIZE = 40;
export const DRAG_HANDLE_COLUMN_ID = 'dragHandle';
